const PriceSource = ({
    localHotelDetailsState,
    setLocalHotelDetailsState,
    pa,
    setPa
}) => {
    const priceOptions = [
        { label: "Reception", value: "RECEPTION" }, 
        { label: "Channel Manager", value: "CHANNEL_MANAGER" }
    ]
    return (
        <div className="mt-8">
            <div className="font-body text-[18px] mb-2">
                Price Source
            </div>
            <div className="flex items-center gap-6">
                {priceOptions.map(priceOption => (
                    <div key={"price_" + priceOption?.value} className="flex items-center gap-2">
                        <input
                            type="radio"
                            className="accent-primary"
                            name="price-source"
                            checked={pa?.bookingEnginePriceSource === priceOption?.value}
                            onChange={() =>{
                                const newPa = { ...pa,
                                        bookingEnginePriceSource:  priceOption?.value,
                                    };
                                setLocalHotelDetailsState({
                                    ...localHotelDetailsState,
                                    priceAdjustment: {
                                        ...newPa
                                    }
                                });
                                setPa(newPa);
                            }
                            }
                        />
                        <label className="capitalize">{priceOption?.label}</label>
                    </div>
                ))}
            </div></div>
    );

}
export default PriceSource;